angular.module('rjmNg.controllers').controller('unshareDashCtrl', [
  "$scope"
  "$modal"
  "$http"
  "$location"
  "appRoute"
  "dashboardService"
  "app"
  "$url"
  (
    $scope,
    $modal,
    $http,
    $location,
    appRoute,
    dashboardService,
    app,
    $url
  ) ->
    # Unshare yourself from a dashboard and redirect to the user's default dashboard
    $scope.unshareDashboard = (modal) =>
      $scope.error = ''

      $http(
        method: 'POST'
        url: $url("/client/#{app.getClientId()}/dashboard/#{dashboardService.dashboard.id}/unshare")
      )
      .then( (response) =>
        $scope.error = ''
        modal('hide')

        app.deleteDashboard(dashboardService.dashboard.id)

        # Announce what we're doing
        dashboardService.updateGlobalSearch()

        # Redirect the user to another dashboard
        defaultDash = app.getDefaultDashboard()
        $location.path appRoute("/#{defaultDash.id}") if defaultDash?
        $location.replace()

      )
      .catch( (error) ->
        if error.data?.error_p1
          $scope.error = error.data.error_p1
        else
          $scope.error = "There was an error leaving this dashboard.  Please try again.  If the problem continues, contact support."
      )

    $scope.closeModal = ->
      $scope.hide()

    # General variables
    $scope.error = ''

])
